import { defineStore } from 'pinia'

export enum NotificationIconEnum {
  Warning,
  Clipboard,
}

export interface Notification {
  id: string
  title: string
  text?: string | undefined
  icon: NotificationIconEnum
}

export interface NotificationsState {
  notifications: Notification[]
}

// short random string for ids - WARNING: not guaranteed to be unique
const randomId = (length = 6): string => {
  return Math.random()
    .toString(36)
    .substring(2, length + 2)
}

export const useNotificationStore = defineStore('notification-store', {
  state: (): NotificationsState => ({
    notifications: [],
  }),
  actions: {
    addNotification(
      icon: NotificationIconEnum,
      title: string,
      text?: string | undefined
    ): void {
      const newId = randomId(6)
      this.notifications.push({
        id: newId,
        title,
        text,
        icon,
      })

      setTimeout(() => {
        this.removeNotification(newId)
      }, 5000)
    },
    removeNotification(id: string): void {
      this.notifications = this.notifications.filter((x) => x.id !== id)
    },
  },
})
